module.exports = __webpack_public_path__ + "img/search-404.576b0f43.png";